import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

interface AttachmentCountBadgeProps {
  count: number;
  size?: 'small' | 'medium';
}

/**
 * Badge component to display attachment count.
 * Overlaps the file icon when used in section headers. Hides when there are no attachments.
 */
export const AttachmentCountBadge: React.FC<AttachmentCountBadgeProps> = ({
  count,
  size = 'small',
}) => {
  if (count <= 0) {
    return null;
  }

  const sizeStyles = size === 'small' ? styles.badgeSmall : styles.badgeMedium;
  const textStyles = size === 'small' ? styles.textSmall : styles.textMedium;

  return (
    <View testID="attachment-badge-container" style={[styles.badge, sizeStyles]}>
      <Text style={[styles.text, textStyles]}>{count}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  badge: {
    borderRadius: 10,
    minWidth: 20,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ff6b35',
  },
  badgeSmall: {
    paddingHorizontal: 6,
    paddingVertical: 2,
    minWidth: 18,
    borderRadius: 9,
  },
  badgeMedium: {
    paddingHorizontal: 8,
    paddingVertical: 3,
    minWidth: 22,
    borderRadius: 11,
  },
  text: {
    color: '#FFFFFF',
    fontWeight: '600',
    textAlign: 'center',
  },
  textSmall: {
    fontSize: 10,
  },
  textMedium: {
    fontSize: 12,
  },
});
